import React from 'react'
import {DOWNLOAD_ANDROID_APP_LINK,DOWNLOAD_IOS_APP_LINK,PRIVACY_POLICY_LINK,TERMS_OF_SERVICE_LINK,SUPPORT_LINK,GET_CARDS_LINK} from '../externalLinks'


class FooterDesktop extends React.Component{

  render() {   

    return(

		  <div className='footerDesktop'>
		  	<div className='footerDesktop-top'>
		  	{!this.props.mobileOS &&
			    <a className='footerDesktop-top-link' href={DOWNLOAD_IOS_APP_LINK} target='_blank'>
			      GET iOS APP
			    </a>
			  }
			  {!this.props.mobileOS &&
			    <a className='footerDesktop-top-link' href={DOWNLOAD_ANDROID_APP_LINK} target='_blank'>
			      GET ANDROID APP
			    </a>
			  }

			  {this.props.mobileOS === 'iPhone' &&
			    <a className='footerDesktop-top-link' href={DOWNLOAD_IOS_APP_LINK}>
			      GET iPHONE APP
			    </a>
			  }

			  {this.props.mobileOS === 'Android' &&
			    <a className='footerDesktop-top-link' href={DOWNLOAD_ANDROID_APP_LINK}>
			      GET ANDROID APP
			    </a>
			  }

			  {this.props.mobileOS === 'iPad' &&
			    <a className='footerDesktop-top-link' href={DOWNLOAD_IOS_APP_LINK}>
			      GET iPAD APP
			    </a>
			  }

			    <a className='footerDesktop-top-link' href={GET_CARDS_LINK} target='_blank' >
			      GET CARDS
			    </a>
			    <a className='footerDesktop-top-link' href={PRIVACY_POLICY_LINK} target='_blank' >
			      PRIVACY POLICY
			    </a>
			    <a className='footerDesktop-top-link' href={TERMS_OF_SERVICE_LINK} target='_blank' >
			      TERMS OF SERVICE
			    </a>
			    <a className='footerDesktop-top-link' href={SUPPORT_LINK} target='_blank' >
			      SUPPORT
			    </a>
			    <a className='footerDesktop-top-link footerDesktop-top-link--email'>
			      HELLO@PLICKERS.COM
			    </a>
			  </div>
		    <div className='footerDesktop-bottom'>
		    	© PLICKERS 2018
		    </div>
		  </div>

		)
	}
}

export default FooterDesktop
